/**
 * ProvenanceLine — the static data-source one-liner that renders directly
 * under the property address on the public property-file page.
 *
 * Per the voice mandate (`feedback-voice-mandate` memory), the source list
 * MUST match the sources actually rendered on the page. HM Land Registry
 * is intentionally OMITTED here until the Title row ships (v1.2 item 4
 * removed it pending HMLR integration; the title-summary service is
 * stub-only without LAND_REGISTRY_API_KEY). Restore HMLR to this string
 * when the Title row lands.
 *
 * No social-proof phrasing ("Used by N buyers") — we have no numbers.
 *
 * Lives in its own component so the same string can be reused by the
 * signed-in /account/property/:id surface without duplication.
 */
export const PROVENANCE_TEXT =
  'Data sourced from the Environment Agency, MHCLG, and the EPC Register.';

export default function ProvenanceLine() {
  return (
    <p className="mt-2 text-sm text-slate-600" data-testid="provenance-line">
      {PROVENANCE_TEXT}
    </p>
  );
}
